import { NextPage } from 'next';
import { useMemo } from 'react';
import Head from 'next/head';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

// components
import DefaultLayout from '@components/_templates/DefaultLayout';
import Title from '@components/_atoms/Title';
import withAuth from '@components/hocs/withAuth';
import EditContent from '@components/_templates/user/EditContent';

// constants
import { useTranslation } from 'next-i18next';
import { MOBILE_MODE } from '@constants/size';

const EditWrapper = styled.div`
  width: 100%;
  padding: 110px 0;
  margin: 0 auto;

  @media ${MOBILE_MODE} {
    padding: 104px 0;
  }
`;

const TitleWrapper = styled.div`
  margin-bottom: 40px;
`;

const Edit: NextPage = () => {
  const { t } = useTranslation('user');
  const router = useRouter();

  const { type } = router.query;

  const title = useMemo(() => {
    switch (type) {
      case 'password':
        return t('edit.password-mainTitle');
      case 'company_info':
        return '사업자 정보 변경하기';
      case 'company_name':
          return 'Change Company Name';
      case 'name':
        return t('edit.name-mainTitle');
      case 'phone':
        return t('edit.phone-mainTitle');
      case 'company_department':
        return t('edit.companyDepartment-mainTitle');
      case 'company_title':
        return t('edit.companyTitle-mainTitle');
      case 'material_alarm':
        return t('mypage.material-alarm');
      default:
        return '';
    }
  }, [type]);

  return (
    <>
      <Head>
        <title>{t('edit.meta-title')}</title>
        <meta name="title" content={t('edit.meta-title')} />
      </Head>
      <DefaultLayout>
        <EditWrapper>
          <TitleWrapper>
            <Title content={title} />
          </TitleWrapper>

          {/* EditContent */}
          <EditContent />
          {/* EditContent end */}
        </EditWrapper>
      </DefaultLayout>
    </>
  );
};

export const getStaticProps = async ({ locale }: { locale: any }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['user', 'common', 'component', 'materialnoti'])),
  },
});

export default withAuth(Edit);
